<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    //获取界面宽高
    this.$_getSize();
    //修改状态宽高
    this.$_resize();
  },
  methods: {
    $_getSize() {
      this.$store.commit('CHANGE_SIZE', { width: this.wwidth(), height: this.wheight() });
    },
    $_resize() {
      window.onresize = () => {
        this.$_getSize();
      }
    },
    wwidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidht
    },
    wheight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    }
  }
}
</script>

<style>
  html{
    font-size:16px;
  }
  @media screen and (max-width:768px) {
    html{
     font-size:14px;
    }
  }
  * {
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    position: relative;
  }
</style>
